export default __webpack_public_path__ + "static/media/Leeds.97eb13ea.png";